export enum InstitutionType 
{
    IES = 1,
    CI = 2, 
}